/**
 * Helper pour gérer une phase d'init commune aux mixins
 */

export default function mixnit_addHook(ctx, type, fn) {
    if (!ctx._hooks) {
        ctx._hooks = { beforeInit: [], afterInit: [] }
    }

    ctx._hooks[type].push(fn)

    return ctx
}
